import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import { propTypes } from '../../util/types';
import config from '../../config';
import { Button, FieldCheckboxGroup, Form } from '../../components';

import css from './EditListingFeaturesForm.module.css';

const EditListingFeaturesFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        disabled,
        ready,
        rootClassName,
        className,
        name,
        handleSubmit,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        filterConfig,
        isTrainee,
      } = formRenderProps;

      const filters = filterConfig || config.custom.filters;

      const classes = classNames(rootClassName || css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = disabled || submitInProgress;

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingFeaturesForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingFeaturesForm.showListingFailed" />
        </p>
      ) : null;
      const options = isTrainee
        ? findOptionsForSelectFilter('workDomains', filters).map(a => {
            if (a.hasOwnProperty('qualified')) {
              a.disabled = a.qualified;
            }
            return a;
          })
        : findOptionsForSelectFilter('workDomains', filters);
      const additionalQualificationsOptions = findOptionsForSelectFilter(
        'additionalQualifications',
        filters
      );
      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          {errorMessageShowListing}

          <div className={css.sectionContainer}>
            <h2 className={css.sectionTitle}>
              <FormattedMessage id="EditListingFeaturesForm.workDomainsTitle" />
            </h2>

            <FieldCheckboxGroup
              className={css.features}
              id={name}
              name={name}
              options={options}
              label={'Choose from the list below'}
              twoColumns={true}
            />
          </div>

          <div className={css.sectionContainer}>
            <h2 className={css.sectionTitle}>
              <FormattedMessage id="EditListingFeaturesForm.additionalQualificationsTitle" />
            </h2>
            <FieldCheckboxGroup
              className={css.features}
              id="additionalQualifications"
              name="additionalQualifications"
              // label={additionalQualificationsLabel}
              label="Choose from the list below"
              options={additionalQualificationsOptions}
            />
          </div>

          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingFeaturesFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  name: string.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  additionalQualificationsOptions: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
  filterConfig: propTypes.filterConfig,
};

const EditListingFeaturesForm = EditListingFeaturesFormComponent;

export default EditListingFeaturesForm;
